import React, { PureComponent } from 'react';
import _ from 'lodash';
import * as deviceInfoService from '../utils/general/deviceInfoService';
import $ from 'jquery';

interface IImageEnlargePopupProps {
    bodySource: any;
}

let modalWidth = 0;
let modalHeight = 0;

class ImageEnlargePopup extends PureComponent<IImageEnlargePopupProps, any> {
    public modalBodyRef: any;
    public modalWindowRef: any;
    public bodyObj: any;

    constructor(props: IImageEnlargePopupProps) {
        super(props);
        this.modalBodyRef = React.createRef();
        this.modalWindowRef = React.createRef();
        this.bodyObj = document.querySelector('body');
        this.state = {
        };
    }

    public closeModal(event: any) {
        // Important!!! the close function can through bubbling propagation, So don't need write any code in here!
    }

    public componentDidMount() {
        $('.modal-fullscreen').css({'visibility': 'hidden'});
        this.modalResizable();
        window.addEventListener('resize', _.throttle(_.bind(this.modalResizable, this), 200));
    }

    public modalResizable() {
        setTimeout(() => {  // need the timeout to render the image first
            let img: any = $('.modal-enlarged-image-container div.image-container img');
            if (!img.length) {
                img = $('.modal-enlarged-image-container img');
            }
            const max_width = 1000;

            const newImg = new Image();
            newImg.src = img.attr('src');
            newImg.onload = () => {
                let imgWidth = 0;
                let imgHeight = 0;
                document.body.appendChild(newImg);
                imgWidth = newImg.offsetWidth;
                imgHeight = newImg.offsetHeight;

                document.body.removeChild(newImg);

                modalWidth = imgWidth > max_width ? max_width + 100 : imgWidth + 100;
                modalHeight = imgWidth > max_width ? ((max_width / imgWidth) * imgHeight) + 102 : imgHeight + 102;

                img.css({
                    'width': imgWidth + 'px',
                    'height': (imgWidth > max_width ? ((max_width / imgWidth) * imgHeight) : imgHeight) + 'px',
                    'maxWidth': max_width + 'px'
                });
                if (imgWidth > 1000 && deviceInfoService.isIE()) { // in ie, image has it's default width and height, so we need to set auto value for image' width & height in ie when the width is > 1000
                    img.css({
                        'width': 'auto',
                        'height': 'auto'
                    });
                }

                const bodyHeight: number = ($(window) as any).height();
                const bodyWidth: number = ($(window) as any).width();

                let getModalHeight = 0;
                let getModalWidth = 0;

                if (bodyWidth < 1000) {
                    getModalHeight = bodyHeight - 60;
                    getModalWidth = bodyWidth - 30;
                    $('.modal-enlarged-image').css({
                        'height': getModalHeight + 'px',
                        'width': getModalWidth + 'px',
                        'position': 'fixed',
                        'top': '50px',
                        'left': '10px',
                        'bottom': '20px', 'right': '10px' });
                } else {
                    if (modalHeight > bodyHeight) {
                        getModalHeight =  bodyHeight - 20;
                        getModalWidth = modalWidth > bodyWidth ? bodyWidth : modalWidth;
                        $('.modal-enlarged-image').css({
                            'height': getModalHeight + 'px',
                            'width': getModalWidth + 'px',
                            'position': 'relative',
                            'top': '0',
                            'left': '0',
                            'bottom': '0'
                        });
                    } else {
                        getModalHeight =  modalHeight;
                        getModalWidth = modalWidth;
                        $('.modal-enlarged-image').css({
                            'height': modalHeight + 'px',
                            'width': modalWidth + 'px',
                            'position': 'relative',
                            'top': '0',
                            'left': '0',
                            'bottom': '0'
                        });
                    }
                }
                $('.image-enlarge-modal').outerHeight(getModalHeight).outerWidth(getModalWidth);
                $('.modal-fullscreen').css({ 'visibility': 'visible' });
            };
        }, 500);
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', _.throttle(_.bind(this.modalResizable, this), 200));
    }

    public enterPressedCloseModal(event: any) {
        const key = event.keyCode || event.which;
        if (key === 13 || key === 27 || key === 32) {
            $('#modalClose').click();
        }
    }

    public render() {
        const { bodySource } = this.props;

        return (
            <React.Fragment>
                <div className="modalWindow modal-fullscreen" role="dialog" aria-modal="true" tabIndex={-1} aria-labelledby="Figure Modal" style={{ visibility: 'hidden' }}>
                    <div className="rendition-modal-window" ref={this.modalWindowRef} style={{ position: 'relative'}}>
                        <span role="button" tabIndex={0} id="modalClose" aria-label="Close Dialog" onClick={(e) => this.closeModal(e)} onKeyPress={(e: any) => this.enterPressedCloseModal(e)} className="enlarge-img-close-button"></span>
                        <div ref={this.modalBodyRef} className="modal-body image-enlarge-modal" style={{ overflow: 'auto', backgroundColor: 'white' }}>
                            <div className="modal-enlarged-image-container">
                                {typeof bodySource === 'string' && bodySource !== '' &&
                                    (<div className='image-container' dangerouslySetInnerHTML={{__html: bodySource}}></div>)
                                }
                                {typeof bodySource === "object" &&
                                    (bodySource)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop in" style={{ zIndex: -1 }}></div>
            </React.Fragment>
        );
    }
}

export default ImageEnlargePopup;
